// extracted by mini-css-extract-plugin
export default {"l_QuantityController_main":"QuantityController_l_QuantityController_main__rbiDj"};